export enum alertType {
  INFORMATION = 'information',
  ALERT = 'alert',
  WARNING = 'warning',
}
